<template>
  <div class="caseList" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="装修案例" :showBack="true"></my-header>
    <div class="option-labels">
      <div v-if="isLabelNum == 0" class="option-item selected">施工案例</div>
      <div v-if="isLabelNum != 0" class="option-item" @click="isLabel(0)">施工案例</div>
      <div v-if="isLabelNum == 1" class="option-item selected">竣工案例</div>
      <div v-if="isLabelNum != 1" class="option-item" @click="isLabel(1)">竣工案例</div>
    </div>
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" style="font-size: 0.25rem" :auto-fill ='false' bottomLoadingText = '加载更多' ref="loadmore">
      <div class="project-list">
        <div class="project-item general-box-shadow" v-for="caseProject in caseList" @click="openProject(caseProject.projectId,caseProject.onestopProjectName)">
          <img v-if="caseProject.onestopProject.cover" :src="imgUrl + caseProject.onestopProject.cover  | ossProcess(690, 320)">
          <img v-if="!caseProject.onestopProject.cover && caseProject.type != '1'" src="../../assets/icon-project-default-cover.png">
          <img v-if="!caseProject.onestopProject.cover && caseProject.type == '1'" src="../../assets/icon-supervisor-case-cover.png">
          <div class="project-info">
            <div class="name">{{caseProject.onestopProjectName | projectNameConvert}}</div>
            <div>{{caseProject.onestopProject.houseLayout}}</div>
          </div>
          <div class="project-evaluate">
            <div v-if="caseProject.status == '4'" class="project-status">施工中</div>
            <div v-if="caseProject.status == '5'" class="project-status">验收中</div>
            <div v-if="caseProject.status == '6'" class="project-status">已完工</div>
          </div>
        </div>
      </div>
      <div v-if="allLoaded && caseList.length > 0" style="text-align: center;padding-top: 0.2rem;">没有更多案例信息了</div>
    </mt-loadmore>
    <div class="black-page" v-if="caseList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无相关案例</div>
    </div>
  </div>
</template>

<script>
  import Header from '../../components/header/Header'
  import {Toast} from 'mint-ui'
  import {imgUrl,shareIcon} from '../../config'
  import shareService from '../../service/share/ShareService'
  import onestopProjectSupervisorService from '../../service/onestop/OnestopProjectSupervisorService'

  export default {
    name: 'CaseList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        isLabelNum:0,
        status:4,
        caseList:[],
        companyId:'',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        allLoaded: false,
        pageNo:1,
        autoFill:false,
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.companyId = this.$route.query.companyId;
      if (this.global.labelSelected) {
        this.labelNum = this.global.labelSelected;
        this.global.labelSelected = '';
        this.isLabel(this.labelNum);
      } else {
        this.getCaseList(this.status);
      }
      this.initWechatShare();
    },
    methods: {
      isLabel(num){
        if(num == 1){
          this.isLabelNum=1;
          this.status= 5;
          this.pageNo = 1
          this.getCaseList(this.status);
        }else {
          this.isLabelNum=0;
          this.status= 4;
          this.pageNo = 1
          this.getCaseList(this.status);
        }
      },
      openProject(id,projectName){
        this.global.labelSelected = this.isLabelNum;
        this.pageNo == 1
        this.$router.push({name:'CompanyProject',query:{id:id,projectName}});
      },
      async getCaseList(status,onCancel = function(){}){
        let result = await onestopProjectSupervisorService.list("",status,this.pageNo,this.companyId);
        if(result.code == 0){
          if(this.pageNo == 1){
            this.caseList = [];
          }
          for(let project of result.data.result){
            if(project.status != 7){
              if(project.type == '6'){
                if(project.onestopProject.renderings){
                  let renderingsArray = project.onestopProject.renderings.split(',');
                  project.onestopProject.cover = renderingsArray[0];
                }
              }
              this.caseList.push(project);
            }
          }
          this.allLoaded = result.data.lastPage;
          onCancel();
          for (let project of this.caseList){
            if(project.renderings){
              let renderingsArray = project.renderings.split(',');
              project.cover = renderingsArray[0];
            }
          }
        }else {
          Toast('获取项目案例信息失败');
        }
      },
      loadBottom(){
        this.pageNo++;
        this.getCaseList(this.status,()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      async initWechatShare(){
        let title = "水木家居商城真实案例";// 分享标题
        let desc = ""; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  .caseList{
    background: white;
    font-size: 0.32rem;
    color: #7f7d7c;
  }
  .option-labels{
    display: flex;
    height: 0.9rem;
    margin-left: 0.3rem;
    line-height: 0.9rem;
    .option-item{
      margin-right: 0.27rem;
    }
    .selected{
      font-size: 0.36rem;
      font-weight: bold;
      color: #191818;
    }
  }
  .project-list{
    width: 6.9rem;
    margin: 0 auto;
    .project-item {
      position: relative;
      margin-bottom: 0.2rem;
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
      img{
        width: 6.9rem;
        height: 3.2rem;
        display: block;
      }
      .project-info{
        display: flex;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.28rem;
        .name{
          margin-left: 0.4rem;
          margin-right: 0.5rem;
          color: #191818;
          font-size: 0.32rem;
          font-weight: bold;
        }
      }
      .project-evaluate{
        position: absolute;
        top: 0rem;
        right: 0.44rem;
        width: 0.58rem;
        height: 0.78rem;
        background: url("../../assets/icon-evaluate-white-bg.png") no-repeat;
        background-size: 100%;
        font-size: 0.18rem;
        font-weight: bold;
        color: #222633;
        text-align: center;
        .project-status{
          margin-top: 0.2rem;
        }
      }
    }
  }
</style>

